import { colors } from '../../../../../../../../../colorVars';
import { Body3 } from '../../../../../../../../../components/atomic/text/Text';
import ApplyRounding from '../../../../../../../../../utils/math/ApplyRounding';

export function tradePlanPnlUpdateBuilder({parsedStatusObj}) {
  const { positionPnl, planPnl } = parsedStatusObj;
  return (
    <td>
      <Body3 fontWeight={500} color={colors.lightGrey}>
        Position pnl:{' '}
        {positionPnl ? '$' + ApplyRounding(Number(positionPnl), 2) : 'N/A'}.
        Plan pnl: {planPnl ? '$' + ApplyRounding(Number(planPnl), 2) : 'N/A'}.
      </Body3>
    </td>
  );
}
